<template>
  <div class="mainContainer">
    <div class="search-from">
      <el-form ref="searchForm" :inline="true" style="text-align: left">
        <el-form-item>
          <el-input
            v-model.trim="searchForm.goodsCode"
            placeholder="商品基库ID"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model.trim="searchForm.name"
            placeholder="产品名称"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model.trim="searchForm.approvalNumber"
            placeholder="批准文号"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model.trim="searchForm.factory"
            placeholder="生产厂家"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <goods-three-class
          ref="three-class"
          :formTool="searchForm"
          :isShowLable="false"
          :lableText="'商品分类'"
          :placeholderText="'商品分类'"
          :styleLable="'width:130px;margin-right:10px;'"
        ></goods-three-class>

        <el-form-item>
          <el-select
            size="mini"
            v-model="searchForm.goodsType"
            placeholder="商品类型"
            style="width: 120px"
          >
            <el-option
              v-for="item in goodsTypeList"
              :label="item.name"
              :value="item.value"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
            size="mini"
            v-model="searchForm.businessScopeName"
            placeholder="经营范围"
            style="width: 120px"
          >
            <el-option
              v-for="item in scopeList"
              :label="item.name"
              :value="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset('searchForm')">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="addProduct"
            >添加新产品</el-button
          >
        </el-form-item>
      </el-form>
      <div class="matchView">
        <div
          v-for="(item, index) in matchTypeList"
          :key="index"
          class="matchRow"
          :class="matchTypeSelectIndex == index ? 'matchRowSelect' : ''"
          @click="changeMatchType(index)"
        >
          <span
            class="matchTitle"
            :class="matchTypeSelectIndex == index ? 'matchTitleSelect' : ''"
            >{{ item.name }}</span
          >
          <span
            class="matchCount"
            :class="matchTypeSelectIndex == index ? 'matchCountSelect' : ''"
            >{{ item.count }}</span
          >
        </div>
      </div>
    </div>
    <div class="matchContent">
      <myTable
        :table-data="tableData"
        :index="index"
        :selection="false"
        :page="page"
        :showpage="true"
        :operation="false"
        v-loading="loading"
        :table-option.sync="tableOption"
        @page-change="getList"
        :expand="false"
        :maxHeight="tableHeight"
        v-if="tableHeight"
      >
        <template slot="goodsCode" slot-scope="scope">
          <el-link
            @click="checkDetails(scope.row, 1)"
            :underline="false"
            style="text-decoration: underline"
          >
            {{ scope.row.goodsCode }}
          </el-link>
        </template>
        <template slot="goodsClass" slot-scope="scope">
          <span v-if="scope.row.goodsOneClassName">
            {{ scope.row.goodsOneClassName }}
          </span>
          <span v-if="scope.row.goodsTwoClassName">
            /{{ scope.row.goodsTwoClassName }}
          </span>
          <span v-if="scope.row.goodsThreeClassName">
            / {{ scope.row.goodsThreeClassName }}
          </span>
        </template>
        <!-- goodsType -->
        <template slot="image" slot-scope="scope">
          <span
            style="display: flex; align-items: center; justify-content: center"
          >
            <ImgUpload
              v-model="scope.row.image"
              @onRemoveHandler="onRemoveHandler(scope.row)"
              @onSuccessUpload="onSuccessUpload(scope.row)"
              :limit="1"
              style="position: relative; top: -8px"
            >
            </ImgUpload>
          </span>
        </template>
        <template slot="businessScopeName" slot-scope="scope">
          <div class="scopeName">
            <span>{{ scope.row.businessScopeName }}</span>
            <i
              class="el-icon-edit-outline"
              style="color: #f5222d"
              @click="editScope(scope.row)"
            ></i>
          </div>
        </template>

        <template slot="goodsType" slot-scope="scope">
          <span v-if="scope.row.goodsType == 'DRUG'"> 药品 </span>
          <span v-if="scope.row.goodsType == 'FOOD'"> 食品 </span>
          <span v-if="scope.row.goodsType == 'MADI'"> 医疗器械 </span>
          <span v-if="scope.row.goodsType == 'TCMDP'"> 中药饮片 </span>
          <span v-if="scope.row.goodsType == 'OTHER'"> 其他 </span>

          <span
            v-if="
              scope.row.goodsType != 'DRUG' &&
              scope.row.goodsType != 'FOOD' &&
              scope.row.goodsType != 'MADI' &&
              scope.row.goodsType != 'TCMDP' &&
              scope.row.goodsType != 'OTHER'
            "
          >
            {{ scope.row.goodsType }}
          </span>
        </template>
        <template slot="operation" slot-scope="scope">
          <div class="operationView">
            <el-link
              v-if="
                permissions.goodsManage_depotList_superedit &&
                scope.row.status == 'ALREADY'
              "
              type="primary"
              :underline="false"
              @click="editProduct(scope.row, 2)"
              class="oprationLink"
            >
              编辑
            </el-link>
            <el-link
              v-if="
                permissions.goodsManage_depotList_edit &&
                scope.row.status != 'ALREADY'
              "
              type="primary"
              :underline="false"
              @click="editProduct(scope.row, 2)"
              class="oprationLink"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              :disabled="
                scope.row.status == 'PERFECT' || scope.row.status == 'SOLDOUT'
                  ? false
                  : true
              "
              v-if="permissions.goodsManage_depotList_audit"
              @click="auditGoods(scope.row)"
              class="oprationLink"
            >
              审核
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              v-if="permissions.goodsManage_depotList_offLine"
              :disabled="scope.row.status != 'ALREADY' ? true : false"
              @click="offLine(scope.row)"
              class="oprationLink"
            >
              全网下架
            </el-link>

            <el-link
              type="primary"
              v-if="permissions.second_audit_delete"
              :underline="false"
              @click="deleteGoods(scope.row)"
              class="oprationLink"
            >
              删除
            </el-link>
          </div>
        </template>
      </myTable>
    </div>
    <el-dialog
      title="确认审核"
      class="dialogClass"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      style="margin-top: 25vh"
    >
      <div>
        审核后，商品在基库中允许商家选择上架，并且会通知发起该商品审核的商家，商品审核通过
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择经营范围"
      :visible.sync="scopeialogVisible"
      width="40%"
      :before-close="handleCloseScope"
    >
      <el-button
        v-for="(item, index) in scopeList"
        :key="index"
        size="small"
        style="margin: 10px 0px 0px 10px"
        @click="editScopeAction(item)"
        >{{ item.name }}</el-button
      >
      <div style="height: 30px"></div>
    </el-dialog>
  </div>
</template>
<script>
import ImgUpload from "@/components/imgUpload";
import myTable from "@/components/myTable";
import avater from "/public/img/default.png";
import getComList from "@/utils/getComList";
import GoodsThreeClass from "@/components/goodsThreeClass";
import {
  addImages,
  updateBaseGoodsImage,
  updateScope,
  getBaseAmount,
} from "@/api/commodityreference";
import {
  queryGoodsBasePage,
  auditGoodsBase,
  offlineGoodsBase,
  deleteGoods,
  getGoodsSkuCount,
} from "@/api/goodsManage/baseDepot";
import { mapGetters } from "vuex";

export default {
  components: { myTable, GoodsThreeClass, ImgUpload },
  props: {},
  data() {
    return {
      dialogVisible: false,
      loading: false,
      avater: avater,
      searchForm: {
        goodsOneClassId: "",
        goodsTwoClassId: "",
        goodsThreeClassId: "",
      },
      scopeList: [],
      tableData: [],
      goodsTypeList: [],
      operation: false,
      selection: true,
      index: false,
      tableOption: [
        { label: "基库ID", prop: "goodsCode", width: 150, slot: true },
        { label: "产品名称", prop: "name", width: 150 },
        {
          label: "图片",
          prop: "image",
          slot: true,
          width: 150,
          align: "center",
        },
        { label: "生产厂家", prop: "factory", width: 150 },
        { label: "规格", prop: "specification", width: 150 },
        { label: "批准文号", prop: "approvalNumber", width: 150 },
        {
          label: "经营范围",
          prop: "businessScopeName",
          slot: true,
          width: 150,
        },
        { label: "商品类型", prop: "goodsType", slot: true, width: 100 },
        { label: "商品分类", prop: "goodsClass", slot: true, width: 150 },
        { label: "修改时间", prop: "updateTime", width: 170 },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 200,
          fixed: "right",
          align: "center",
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      isReport: true,
      params: {}, // 当前行数据
      scopeialogVisible: false,
      matchTypeList: [
        { name: "全部", count: 0, type: "defalut" },
        { name: "已审核", count: 0, type: "already" },
        { name: "已匹配未审核", count: 0, type: "matching" },
        { name: "已完善未审核", count: 0, type: "perfect" },
        { name: "基库无经营范围", count: 0, type: "businessScope" },
        { name: "基库无商品分类", count: 0, type: "classify" },
        { name: "基库无商品类型", count: 0, type: "type" },
        { name: "基库无图", count: 0, type: "image" },
        { name: "有图无分类", count: 0, type: "withImageNoClassify" },
      ],
      matchTypeSelectIndex: 0,
      tableHeight: "",
      goodsSkus: 0, //选中下架时的商品的sku数量
    };
  },
  filters: {},
  created() {},
  mounted() {
    // 获取所有商品类型
    this.typeList();
    this.getList(1);
    this.getBaseAmount();
    this.tableHeight = window.innerHeight - 430 + "px";
    this.handleAddListener();
  },
  destroyed() {
    this.handleremoveListener();
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    gethiddenStatus() {
      var isHidden = document.hidden;
      if (isHidden) {
        // 失去焦点
      } else {
        // 进入窗口
        this.getList();
        this.getBaseAmount();
      }
    },
    // 开启
    handleAddListener() {
      document.addEventListener("visibilitychange", this.gethiddenStatus, true);
    },
    // 手动销毁
    handleremoveListener() {
      document.removeEventListener(
        "visibilitychange",
        this.gethiddenStatus,
        true
      );
    },

    changeMatchType(index) {
      this.matchTypeSelectIndex = index;
      this.getList(1);
    },
    async getBaseAmount() {
      const resp = await getBaseAmount();
      if (resp) {
        resp.forEach((v) => {
          this.matchTypeList.forEach((e) => {
            if (v.type == e.type) {
              e.count = v.amount;
            }
          });
        });
      }
    },
    editScope(e) {
      this.scopeialogVisible = true;
      this.params = e;
    },
    editScopeAction(e) {
      const params = {
        goodsId: this.params.id,
        businessScopeId: e.id,
      };
      updateScope(params).then((res) => {
        if (res) {
          this.$message.success("更新成功");
          this.scopeialogVisible = false;
          this.getList();
          this.getBaseAmount();
        }
      });
    },
    handleCloseScope() {
      this.scopeialogVisible = false;
    },
    onRemoveHandler(row) {
      this.params = row;
      const params = {
        goodsId: this.params.id,
        image: "",
      };
      updateBaseGoodsImage(params).then((res) => {
        if (res) {
          this.$message.success("删除成功");
          this.getList();
          this.getBaseAmount();
        }
      });
    },
    // 上传成功
    onSuccessUpload(row) {
      this.params = row;
      this.$nextTick(() => {
        this.concatImage();
      });
    },
    // 关联商品和图片
    concatImage() {
      const params = {
        goodsId: this.params.id,
        image: this.params.image[0],
      };
      updateBaseGoodsImage(params).then((res) => {
        if (res) {
          this.$message.success("上传成功");
          this.getList();
          this.getBaseAmount();
        }
      });
    },
    async typeList() {
      this.goodsTypeList = await getComList.goodsType; //商品类型
      this.scopeList = await getComList.scopeList; //经营范围
    },

    getList(current) {
      const params = Object.assign({}, this.searchForm);
      params.size = this.page.size;
      if (current) {
        this.page.current = 1;
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      params["keyWord"] = this.matchTypeList[this.matchTypeSelectIndex].type; //类型： matching-匹配未审核 businessScope-经营范围 classify-分类 type-类型 image-图片
      // for (const key in params) {
      //   if (Object.hasOwnProperty.call(params, key)) {
      //     const element = params[key];
      //     element = element.trim()

      //   }
      // }
      queryGoodsBasePage(params).then((res) => {
        if (res.code == 0) {
          res.data.records.forEach((e) => {
            e.image = e.image ? [e.image] : [];
          });
          this.page.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },

    /**
     * @functionName: addProduct 添加新产品
     * @description: //pageType
     * 1 商品基库-》 查看 操作：返回）
     * 2 商品基库-》 编辑（操作：保存提交，返回）
     * 3 商品基库-》 创建 （操作：保存提交，返回）
     * 4 商家申请-》详情 （操作：创建，驳回）
     * 5 商家申请-》创建商品基础库 （操作：保存提交，返回）
     * @return {*}
     */
    // 创建
    addProduct() {
      this.goBaseDepotPage("./goodsManage-baseDepot-details?pageType=3");
    },

    // 编辑
    editProduct(row) {
      this.goBaseDepotPage(
        `./goodsManage-baseDepot-details?pageType=2&&id=${row.id}&status=${row.status}`
      );
    },

    // 查看
    checkDetails(row) {
      this.goBaseDepotPage(
        `./goodsManage-baseDepot-details?pageType=1&id=${row.id}&status=${row.status}`
      );
    },
    goBaseDepotPage(pathUrl) {
      let routeData = this.$router.resolve({
        path: pathUrl,
        query: {},
        params: {},
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * @functionName: auditGoods审核 做权限控制，只开放给质管经理
     * @description: auditGoods
     * @return {*}
     */
    auditGoods(row) {
      this.$confirm(
        "审核后，商品在基库中允许商家选择上架，并且会通知发起该商品审核的商家，商品审核通过",
        "确认审核",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.submitAudit(row.id);
        })
        .catch(() => {});
    },

    // 提交审核
    submitAudit(id) {
      auditGoodsBase({ id: id }).then((res) => {
        if (res.code == 0 && res.data) {
          this.$message({
            message: "提交成功！",
            type: "success",
          });
          this.getList(1);
          this.getBaseAmount();
        }
      });
    },

    // 全网下架
    offlineGoodsBaseSubmit(row, value) {
      let params = {
        id: row.id,
        checkReason: value,
      };
      offlineGoodsBase(params).then((res) => {
        if (res.code == 0 && res.data) {
          this.$message({
            message: "提交成功！",
            type: "success",
          });
          this.getList(1);
        }
      });
    },
    // 删除商品 删除时校验商品有没有关联sku，若关联sku的话禁止删除。
    async deleteGoods(e) {
      let _this = this;
      this.$confirm(
        "删除商品后，该商品在基库中消失，请确认是否删除",
        "删除商品",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          _this.deleteGoodsAction(e);
        })
        .catch(() => {});
    },

    async deleteGoodsAction(e) {
      const resp = await deleteGoods(e.id);
      if (resp) {
        this.getList();
        this.getBaseAmount();
      }
    },
    // 获取当前商品sku数量
    async getGoodsSkuCountAction(goodsId) {
      const resp = await getGoodsSkuCount({ goodsId });
      if (resp) {
        this.goodsSkus = resp;
      } else {
        this.goodsSkus = 0;
      }
    },
    /**
     * @offLine: 全网下架 做权限控制，只开放给质管经理
     * @description:
     * @return {*}
     */
    async offLine(row) {
      await this.getGoodsSkuCountAction(row.id);
      const h = this.$createElement;
      const notiStr = this.goodsSkus
        ? `当前商品有${this.goodsSkus}个sku处于销售中状态，请问是否确认全网下架`
        : "";
      this.$prompt(
        h("p", null, [
          h("p", { style: "color: #f5222d" }, notiStr),
          h(
            "p",
            null,
            // { style: 'text-indent: 2em;' },
            "反审核后，商品已上架的商家将会下架该商品，并且商品处于审核未通过状态；平台将向商家发送反审核原因。"
          ),
          // h("p", null, "反审核原因： "),
        ]),
        "反审核原因",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(({ value }) => {
          if (value != "" && value != undefined) {
            value = value.trim();
          }
          if (value == "" || value == undefined) {
            this.$message({
              message: "请填写反审核原因！",
              type: "error",
            });
            return;
          }
          this.offlineGoodsBaseSubmit(row, value);
        })
        .catch((err) => {});
    },

    reset() {
      this.page.current = 1;
      this.searchForm = {
        goodsOneClassId: "",
        goodsTwoClassId: "",
        goodsThreeClassId: "",
      };
      this.$refs["three-class"].resetForm();
      this.getList(1);
    },

    handleClose() {
      this.dialogVisible = false;
    },
    submit() {},
  },
};
</script>
<style lang="scss" scoped>
@import url("./styles/index.scss");
.mainContainer {
  display: flex;
  flex-direction: column;
}
.scopeName {
  cursor: pointer;
}

.matchView {
  display: flex;
  align-items: center;
}

.matchRow {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border: 1px solid #d9d9d9;
  // padding: 8px;
  margin-right: 12px;
  border-radius: 4px;
  min-width: 120px;
  height: 80px;

  .matchTitle {
    font-size: 14px;
    color: #353535;
  }

  .matchCount {
    font-size: 30px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 700;
    margin-top: 5px;
  }

  .matchTitleSelect {
    color: #fff;
  }

  .matchCountSelect {
    color: #fff;
  }
}

.matchRowSelect {
  background-color: var(--main-color);
}
.matchContent {
  display: flex;
  flex: 1;
  height: 300px;
}
.operationView {
  display: flex;
  flex-direction: column;
  .oprationLink {
    height: 30px;
  }
}
</style>
